import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toSafePushUrl } from '../sw/push-sw-logic';

/**
 * Listens for navigation messages from the push service worker (e.g. on notification click)
 * and navigates within the SPA router without triggering a full page reload.
 */
export function useServiceWorkerNavigation(): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      return;
    }

    const handleMessage = (event: MessageEvent) => {
      if (!event.data || typeof event.data !== 'object') {
        return;
      }

      const payload = event.data as { type?: unknown; url?: unknown };
      if (payload.type === 'navigate') {
        const safeUrl = toSafePushUrl(payload.url);
        navigate(safeUrl);
      }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);
    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
    };
  }, [navigate]);
}
